/*
 * Copyright (c) 2022, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
*/

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { Container, CssBaseline, Typography, Grid, Button } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
    signInContainer: {
        ...theme.custom.clientErrorPage.signInContainer.styles
    },
    signInText: {
        ...theme.custom.clientErrorPage.signInText.styles
    },
    tryAgainBtn: {
        ...theme.custom.clientErrorPage.tryAgainBtn.styles
    },
    loaderContainer: {
        ...theme.custom.clientErrorPage.loaderContainer.styles
    },
}));

function ClientError() {
    const classes = useStyles();
    const history = useHistory();

    return (
        <div>
            <CssBaseline />
            <Container maxWidth="lg" className={classes.signInContainer}>
                <div className={classes.loaderContainer}>
                    <img src="../../themes/default/images/page-not-found.svg" />
                </div>
                <Typography className={classes.signInText}>
                    <FormattedMessage 
                        id='components.shared.clientError.title'
                        defaultMessage='Something went wrong!'
                    />
                </Typography>
                <Typography>
                    <FormattedMessage 
                        id='components.shared.clientError.message'
                        defaultMessage='User or email not found or user session invalid'
                    />
                </Typography>
                <Grid item>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.tryAgainBtn}
                        onClick={() => history.push('/login')}
                        disableElevation
                    >
                        <FormattedMessage
                        id="components.shared.clientError.backButton"
                        defaultMessage="Back to login"
                        />
                    </Button>
                </Grid>
            </Container>
        </div>
    )
}

export default ClientError;
